<template>
  <section>
    <div class="flex md:items-center items-start flex-col md:flex-row justify-between">
      <div class="mb-4">
        <select
          class="mt-1 block w-full pl-3 pr-10 py-2 text-base ring-gray-300 focus:outline-none hover:shadow-lg sm:text-sm rounded-md bg-white ring-1"
          v-model="sessionType"
        >
          <option value="session" selected>Class Earnings</option>
          <option value="course">Class Pack Earnings</option>
          <!-- <option value="private">Private Session Earnings</option> -->
        </select>
      </div>
      <div class="flex md:items-center items-start md:space-x-2 flex-col md:flex-row">
        <DateFilter
          :handleDateChange="handleDateChange"
          :handleDateFilterCategoryChange="handleDateFilterCategoryChange"
          :dateFilterCategory="dateFilterCategory"
          :monthOfMonthAndYear="monthOfMonthAndYear"
          monthOfMonthAndYearId="monthOfMonthAndYear"
          yearOfMonthAndYearId="yearOfMonthAndYear"
          yearId="year"
          startDateId="startDate"
          endDateId="endDate"
          :yearOfMonthAndYear="yearOfMonthAndYear"
          :year="year"
          :startDate="startDate"
          :endDate="endDate"
        />
        <div class="mt-4 md:mt-0">
          <select
            class="form-select mb-1 block w-full pl-3 pr-10 py-2 text-base ring-gray-300 focus:outline-none sm:text-sm rounded-md bg-white ring-1 hover:shadow-lg"
            v-model="show"
          >
            <option value="all" selected>See All</option>
            <option value="public">See Public</option>
            <option value="private">See Private</option>
          </select>
        </div>
      </div>
    </div>
    <TableAlt :thead="tableHead">
      <tbody
        class="bg-white divide-y divide-gray-200"
        v-if="transactionsBySessionsData && transactionsBySessionsData.length"
      >
        <tr v-for="d in transactionsBySessionsData" :key="d.id">
          <td
            class="px-6 py-4 whitespace-nowrap text-sm text-gray-dark capitalize"
          >
            {{ d.title || "-" }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-dark">
            {{ d.subscribed_users }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-dark">
            {{ d.total_webcam_allowed || "-" }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-dark">
            ${{ d.paid_amount }}
          </td>
          <td
            class="px-6 py-4 whitespace-nowrap text-sm text-gray-dark"
            :class="d.status == 'Active' ? 'text-green-light' : ''"
          >
            {{ d.status }}
          </td>
        </tr>
      </tbody>
    </TableAlt>
    <div v-if="loadingStatus">
      <p class="text-center">Loading...</p>
    </div>
    <div v-else>
      <div v-if="!transactionsBySessionsData">
        <EmptyTable :description="'Try adjusting the filters to see more.'" />
      </div>
    </div>
  </section>
</template>

<script>
import DateFilter from "@/components/DateFilter.vue";

import { EmptyTable, TableAlt } from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "EarningsSession",
  components: {
    DateFilter,
    EmptyTable,
    TableAlt,
  },
  data() {
    return {
      tableHead: [
        "Session",
        "Subscribed Users",
        "Webcam Users",
        "Amount",
        "Status",
      ],
      dateFilterCategory: "month",
      yearOfMonthAndYear: "",
      monthOfMonthAndYear: "",
      year: "selectyear",
      startDate: "",
      endDate: "",
      transactionsBySessionsData: [],
      currentPage: 1,
      totalPages: "",
      sessionType: "session",
      show: "all",
    };
  },
  computed: {
    ...mapGetters(["trainerTransactionsBysessions"]),

    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  watch: {
    sessionType: function () {
      this.handlePageChange(this.currentPage);
    },
    show: function () {
      this.handlePageChange(this.currentPage);
    },
  },
  methods: {
    ...mapActions(["postTrainerTransactionsBysessions"]),

    handleDateFilterCategoryChange(event) {
      this.dateFilterCategory = event.target.value;
    },

    async handleDateChange(event) {
      let startDate = null;
      let endDate = null;
      if (event.target.id === "startDate") {
        startDate = event.target.value;
        endDate = this.endDate;
      } else if (event.target.id === "endDate") {
        endDate = event.target.value;
        startDate = this.startDate;
      } else if (event.target.id === "monthOfMonthAndYear") {
        const month = Number(event.target.value);
        const year = this.yearOfMonthAndYear;
        this.monthOfMonthAndYear = month;

        startDate = moment(new Date(year, month, 1)).format("YYYY-MM-DD");
        endDate = moment(new Date(year, month + 1, 0)).format("YYYY-MM-DD");
      } else if (event.target.id === "yearOfMonthAndYear") {
        const year = Number(event.target.value);
        const month = this.monthOfMonthAndYear;
        this.yearOfMonthAndYear = year;
        startDate = moment(new Date(year, month, 1)).format("YYYY-MM-DD");
        endDate = moment(new Date(year, month + 1, 0)).format("YYYY-MM-DD");
      } else if (event.target.id === "year") {
        const year = Number(event.target.value);
        this.year = year;
        startDate = moment(new Date(year, 0, 1)).format("YYYY-MM-DD");
        endDate = moment(new Date(year, 12, 0)).format("YYYY-MM-DD");
      }
      this.startDate = startDate;
      this.endDate = endDate;

      const payload = {
        filter_type: this.dateFilterCategory,
        start_date: startDate,
        end_date: endDate,
        type: this.sessionType,
        show: this.show,
      };
      const query = {
        page: 1,
      };
      this.transactionsBySessionsData = [];
      this.currentPage = 1;
      await this.postTrainerTransactionsBysessions({ payload, query });
      this.transactionsBySessionsData =
        this.trainerTransactionsBysessions &&
        this.trainerTransactionsBysessions.data;
      this.totalPages = this.trainerTransactionsBysessions.last_page;
    },

    async handlePageChange(page) {
      this.currentPage = page;
      const query = {
        page,
      };
      const payload = {
        filter_type: this.dateFilterCategory,
        start_date: this.startDate,
        end_date: this.endDate,
        type: this.sessionType,
        show: this.show,
      };
      this.transactionsBySessionsData = [];
      await this.postTrainerTransactionsBysessions({ payload, query });
      this.transactionsBySessionsData =
        this.trainerTransactionsBysessions &&
        this.trainerTransactionsBysessions.data;
    },
  },
  async created() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    const startDate = moment(new Date(currentYear, currentMonth, 1)).format(
      "YYYY-MM-DD"
    );
    const endDate = moment(new Date(currentYear, currentMonth + 1, 0)).format(
      "YYYY-MM-DD"
    );
    this.yearOfMonthAndYear = currentYear;
    this.monthOfMonthAndYear = currentMonth;
    this.startDate = startDate;
    this.endDate = endDate;

    const payload = {
      filter_type: "month",
      start_date: startDate,
      end_date: endDate,
      type: this.sessionType,
      show: this.show,
    };
    const query = {
      page: this.currentPage,
    };
    await this.postTrainerTransactionsBysessions({ payload, query });
    this.transactionsBySessionsData =
      this.trainerTransactionsBysessions &&
      this.trainerTransactionsBysessions.data;
    this.totalPages =
      this.trainerTransactionsBysessions &&
      this.trainerTransactionsBysessions.last_page;
  },
};
</script>